export interface IDonorDetailsRequest {
    id: number,
    disposition: string,
    dispositionId: number,
    comments: string,
    firstName: string,
    lastName: string,
    birthDate: string,
    phoneNumber: string,
    email: string,
    addressLine1: string,
    donorCity: string,
    donorState: string,
    donorStateId: number,
    donorPostalCode: string,
    closeLoopSurgeryDateTime: string,
    closeLoopEntityTypeId: number,
    closeLoopEntityType: number
}